<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand"
    :class="{ 'navbar-dark': type === 'default' }"
  >
    <a
      href="#"
      aria-current="page"
      class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block active router-link-active"
    >
      {{ $t(pageName + '.value') }}
    </a>
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a
          class="nav-link"
          href="#"
          data-action="search-show"
          data-target="#navbar-search-main"
        >
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <span class="avatar avatar-sm rounded-circle bg-white text-primary">
              {{
                userMe.name
                  ? userMe.name[0].toUpperCase()
                  : userMe.username
                  ? userMe.username[0].toUpperCase()
                  : '-'
              }}
            </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <p class="mb-0 text-lg font-weight-bold">
                {{
                  userMe.name
                    ? userMe.name
                    : userMe.username
                    ? userMe.username
                    : '-'
                }}
              </p>

              <p class="text-sm">
                {{ userMe.role ? userMe.role : '-' }}
              </p>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">{{ $t('welcome.value') }}!</h6>
          </b-dropdown-header>
          <b-dropdown-item href="#/profile">
            <i class="ni ni-single-02"></i>
            <span>{{ $t('myProfile.value') }}</span>
          </b-dropdown-item>
          <b-dropdown-item href="#/settings">
            <i class="ni ni-settings-gear-65"></i>
            <span>{{ $t('settings.value') }}</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="onLogout()">
            <i class="ni ni-user-run"></i>
            <span>{{ $t('logout.value') }}</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import { getUserMe } from '@/services/users';

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description:
        'Look of the dashboard navbar. Default (Green) or light (gray)',
    },
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  watch: {
    $route() {
      this.pageName = this.$route.name;
    },
  },
  mounted() {
    this.$session.start();
    this.getUserMeData();
  },
  data() {
    return {
      pageName: this.$route.name,
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      userMe: {},
    };
  },
  methods: {
    async getUserMeData() {
      var id = this.$session.get('user_id');
      const req = await getUserMe(id);

      if (req.status === 200) {
        this.userMe = req.data;
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    onLogout() {
      this.$session.remove('token');
      localStorage.clear();
      this.$router.push('/landing');
    },
  },
};
</script>
